import {
  withTranslation,
} from 'react-i18next';

import RegattaGroupFieldsView from './RegattaGroupFieldsView';

const TranslatedComponent = withTranslation()(RegattaGroupFieldsView);

const Component = TranslatedComponent;

export default Component;
